import type React from 'react';

export interface ManagePatientsIconProps {
	width?: string | number;
	height?: string | number;
	color?: string;
	'aria-label'?: string;
}

const ManagePatientsIcon: React.FC<ManagePatientsIconProps> = ({
	width = 24,
	height = 24,
	color = 'currentColor',
	'aria-label': ariaLabel = 'Manage Patients Icon',
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-label={ariaLabel}
		style={{ color }}
	>
		<path
			d="M12 10.5C12.7956 10.5 13.5587 10.1839 14.1213 9.62132C14.6839 9.05871 15 8.29565 15 7.5C15 6.70435 14.6839 5.94129 14.1213 5.37868C13.5587 4.81607 12.7956 4.5 12 4.5C11.2044 4.5 10.4413 4.81607 9.87868 5.37868C9.31607 5.94129 9 6.70435 9 7.5C9 8.29565 9.31607 9.05871 9.87868 9.62132C10.4413 10.1839 11.2044 10.5 12 10.5ZM12 9C11.6022 9 11.2206 8.84196 10.9393 8.56066C10.658 8.27936 10.5 7.89782 10.5 7.5C10.5 7.10218 10.658 6.72064 10.9393 6.43934C11.2206 6.15804 11.6022 6 12 6C12.3978 6 12.7794 6.15804 13.0607 6.43934C13.342 6.72064 13.5 7.10218 13.5 7.5C13.5 7.89782 13.342 8.27936 13.0607 8.56066C12.7794 8.84196 12.3978 9 12 9ZM7.5 18C7.30109 18 7.11032 18.079 6.96967 18.2197C6.82902 18.3603 6.75 18.5511 6.75 18.75C6.75 18.9489 6.82902 19.1397 6.96967 19.2803C7.11032 19.421 7.30109 19.5 7.5 19.5H16.5C16.6989 19.5 16.8897 19.421 17.0303 19.2803C17.171 19.1397 17.25 18.9489 17.25 18.75C17.25 18.5511 17.171 18.3603 17.0303 18.2197C16.8897 18.079 16.6989 18 16.5 18H7.5ZM3.75 4.125C3.75 3.42881 4.02656 2.76113 4.51884 2.26884C5.01113 1.77656 5.67881 1.5 6.375 1.5H17.625C18.3212 1.5 18.9889 1.77656 19.4812 2.26884C19.9734 2.76113 20.25 3.42881 20.25 4.125V19.875C20.25 20.5712 19.9734 21.2389 19.4812 21.7312C18.9889 22.2234 18.3212 22.5 17.625 22.5H6.375C5.67881 22.5 5.01113 22.2234 4.51884 21.7312C4.02656 21.2389 3.75 20.5712 3.75 19.875V4.125ZM6.375 3C6.07663 3 5.79048 3.11853 5.5795 3.3295C5.36853 3.54048 5.25 3.82663 5.25 4.125V15H7.5V12.75C7.5 12.3522 7.65804 11.9706 7.93934 11.6893C8.22064 11.408 8.60218 11.25 9 11.25H15C15.3978 11.25 15.7794 11.408 16.0607 11.6893C16.342 11.9706 16.5 12.3522 16.5 12.75V15H18.75V4.125C18.75 3.82663 18.6315 3.54048 18.4205 3.3295C18.2095 3.11853 17.9234 3 17.625 3H6.375ZM5.25 19.875C5.25 20.1734 5.36853 20.4595 5.5795 20.6705C5.79048 20.8815 6.07663 21 6.375 21H17.625C17.9234 21 18.2095 20.8815 18.4205 20.6705C18.6315 20.4595 18.75 20.1734 18.75 19.875V16.5H5.25V19.875ZM15 12.75H9V15H15V12.75Z"
			fill="currentColor"
		/>
	</svg>
);

export default ManagePatientsIcon;
